// import {
//   Form,
//   InputNumber,
//   Modal,
//   Select,
//   Row,
//   Col,
//   Switch,
//   Checkbox,
//   Input,
//   DatePicker,
//   Flex,
// } from "antd";
// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { getCustomers } from "../../store/actions/customers";
// import { getPackage } from "../../store/actions/package";
// import dayjs from "dayjs";
// import { Infinity } from "lucide-react";

// const { Option } = Select;

// const PackageTransactionForm = ({
//   visible,
//   onCreate,
//   onCancel,
//   record,
//   businessType,
// }) => {
//   const [form] = Form.useForm();
//   const dispatch = useDispatch();
//   const customers = useSelector((state) => state.customers.list);
//   const packages = useSelector((state) => state.packageReducer.list);

//   const [unlimitedFields, setUnlimitedFields] = useState({
//     noOfCompanies: false,
//     noOfEways: false,
//     noOfEInvoice: false,
//     noOfUser: false,
//     noOfWp: false,
//   });

//   useEffect(() => {
//     if (record) {
//       console.log("Editing record with values:", {
//         noOfCompanies: record.noOfCompanies,
//         noOfEways: record.noOfEways,
//         noOfEInvoice: record.noOfEInvoice,
//         noOfUser: record.noOfUser,
//         noOfWp: record.noOfWp,
//       });

//       const unlimitedState = {
//         noOfCompanies: record.noOfCompanies === -100,
//         noOfEways: record.noOfEways === -100,
//         noOfEInvoice: record.noOfEInvoice === -100,
//         noOfUser: record.noOfUser === -100,
//         noOfWp: record.noOfWp === -100,
//       };
//       setUnlimitedFields(unlimitedState);
//       form.setFieldsValue({
//         cusId: record.cusId,
//         pId: record.pId,
//         amount: record.amount,
//         paymentMode: record.paymentMode,
//         paymentRec: record.paymentRec,
//         endDate: dayjs(record.endDate, "YYYY-MM-DD"),
//         noOfCompanies: unlimitedState.noOfCompanies
//           ? null
//           : record.noOfCompanies,
//         noOfEways: unlimitedState.noOfEways ? null : record.noOfEways,
//         noOfEInvoice: unlimitedState.noOfEInvoice ? null : record.noOfEInvoice,
//         noOfUser: unlimitedState.noOfUser ? null : record.noOfUser,
//         noOfWp: unlimitedState.noOfWp ? null : record.noOfWp,
//         isMobileApp: record.isMobileApp,
//         isCrm: record.isCrm,
//         isRojmel: record.isRojmel,
//         isToDo: record.isToDo,
//         isDailyWp: record.isDailyWp,
//         referralAmt: record.referralAmt,
//         referralPer: record.referralPer,
//         isDashboardGst: record.isDashboardGst,
//         is2a2b: record.is2a2b,
//         is2stepVerify: record.is2stepVerify,
//         sales_challan: record.sales_challan,
//         sales_invoice: record.sales_invoice,
//         purchase_challan: record.purchase_challan,
//         purchase_invoice: record.purchase_invoice,
//         sales_return: record.sales_return,
//         purchase_return: record.purchase_return,
//         issue: record.issue,
//         receive: record.receive,
//         cash: record.cash,
//         bank: record.bank,
//         jv: record.jv,
//         stock_transfer: record.stock_transfer,
//         share_company: record.share_company,
//         company_wise_master: record.company_wise_master,
//         delete_unused_master: record.delete_unused_master,
//         aamne_saamne_sale_purchase: record.aamne_saamne_sale_purchase,
//         multiple_eway_bill_generate: record.multiple_eway_bill_generate,
//         print_barcode: record.print_barcode,
//         sales_order: record.sales_order,
//         purchase_order: record.purchase_order,
//         bank_import: record.bank_import,
//         bulk_update_suspense_account: record.bulk_update_suspense_account,
//       });
//     } else {
//       form.resetFields();
//       setUnlimitedFields({
//         noOfCompanies: false,
//         noOfEways: false,
//         noOfEInvoice: false,
//         noOfUser: false,
//         noOfWp: false,
//       });
//     }
//   }, [record, form]);

//   useEffect(() => {
//     if (record) {
//       setUnlimitedFields({
//         noOfCompanies: record.noOfCompanies === -100 ? true : false,
//         noOfEways: record.noOfEways === -100 ? true : false,
//         noOfEInvoice: record.noOfEInvoice === -100 ? true : false,
//         noOfUser: record.noOfUser === -100 ? true : false,
//         noOfWp: record.noOfWp === -100 ? true : false,
//       });
//     }
//   }, [record]);

//   useEffect(() => {
//     dispatch(getCustomers());
//     dispatch(getPackage());
//   }, [dispatch]);

//   const formItemLayout = {
//     labelCol: { span: 24 },
//     wrapperCol: { span: 24 },
//   };

//   return (
//     <Modal
//       open={visible}
//       title={record ? "Update Package Transaction" : "Add Package Transaction"}
//       okText="Submit"
//       zIndex={10000}
//       cancelText="Cancel"
//       onCancel={() => {
//         form.resetFields();
//         onCancel();
//       }}
//       onOk={() => {
//         form
//           .validateFields()
//           .then((values) => {
//             const fieldMapping = [
//               "noOfCompanies",
//               "noOfEways",
//               "noOfEInvoice",
//               "noOfUser",
//               "noOfWp",
//             ];

//             fieldMapping.forEach((field) => {
//               if (unlimitedFields[field]) {
//                 values[field] = -100;
//               } else if (
//                 values[field] === undefined ||
//                 values[field] === null
//               ) {
//                 values[field] = 0;
//               }
//             });
//             values.endDate = values?.endDate?.format("YYYY-MM-DD");

//             console.log("Submitting values:", values);
//             onCreate(values);

//             // Reset
//             form.resetFields();
//             setUnlimitedFields({
//               noOfCompanies: false,
//               noOfEways: false,
//               noOfEInvoice: false,
//               noOfUser: false,
//               noOfWp: false,
//             });
//           })
//           .catch((info) => {
//             console.log("Validate Failed:", info);
//           });
//       }}
//       width={1200}
//       // height={750}
//       centered
//       bodyStyle={{ paddingTop: 20 }}
//     >
//       <Form
//         {...formItemLayout}
//         form={form}
//         layout="vertical"
//         name="package_form"
//       >
//         <Row gutter={24}>
//           <Col span={6}>
//             <Form.Item
//               name="cusId"
//               label="Customer"
//               rules={[
//                 {
//                   required: true,
//                   message: "Please select at least one Customer",
//                 },
//               ]}
//             >
//               <Select
//                 placeholder="Select Customer"
//                 style={{ width: "100%" }}
//                 disabled={record?.id}
//                 allowClear
//                 showSearch
//                 filterOption={(input, option) =>
//                   option.children.toLowerCase().indexOf(input.toLowerCase()) >=
//                   0
//                 }
//               >
//                 {customers.map((product) => (
//                   <Select.Option key={product.id} value={product.id}>
//                     {product.name}
//                   </Select.Option>
//                 ))}
//               </Select>
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="pId"
//               label="Package"
//               rules={[
//                 {
//                   required: true,
//                   message: "Please select at least one Package",
//                 },
//               ]}
//             >
//               <Select
//                 placeholder="Select Package"
//                 style={{ width: "100%" }}
//                 disabled={record?.id}
//                 allowClear
//                 showSearch
//                 filterOption={(input, option) =>
//                   option.children.toLowerCase().indexOf(input.toLowerCase()) >=
//                   0
//                 }
//               >
//                 {packages.map((product) => (
//                   <Select.Option key={product.id} value={product.id}>
//                     {product.name}
//                   </Select.Option>
//                 ))}
//               </Select>
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="paymentMode"
//               label="Payment Mode"
//               rules={[
//                 { required: true, message: "Please select a Payment Mode!" },
//               ]}
//             >
//               <Select
//                 showSearch
//                 placeholder="Select a payment Mode"
//                 filterOption={(input, option) => {
//                   // Convert both input and city name to lowercase for case-insensitive search
//                   // return option.children.toLowerCase().includes(input.toLowerCase());
//                 }}
//               >
//                 <Option value={"Razorpay"}>Razorpay</Option>
//                 <Option value={"Cash"}>Cash</Option>
//                 <Option value={"Bank"}>Bank</Option>
//                 <Option value={"NEFT"}>NEFT</Option>
//                 <Option value={"UPI"}>UPI</Option>
//               </Select>
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="paymentRec"
//               label="Payment Status"
//               valuePropName="checked" // This tells the form to treat the checkbox's value as 'checked' or 'unchecked'
//               rules={[
//                 {
//                   required: false,
//                   message: "Please confirm if payment is received!",
//                 },
//               ]}
//             >
//               <Checkbox>Full Payment Received</Checkbox>
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="amount"
//               label="Price"
//               rules={[{ required: true, message: "Please enter the price!" }]}
//             >
//               <InputNumber
//                 placeholder="Enter Price"
//                 style={{ width: "100%" }}
//               />
//             </Form.Item>
//           </Col>

//           {record?.id ? (
//             <>
//               <Col span={6}>
//                 <Form.Item name="endDate" label="End Date">
//                   <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
//                 </Form.Item>
//               </Col>

//               {/* <Col span={4}>
//                 <Form.Item label="Unlimited Companies">
//                   <Switch
//                     checked={unlimitedFields.noOfCompanies}
//                     checkedChildren={<Infinity width={20} style={{ paddingBottom: "3px" }} />}
//                     onChange={(checked) => {
//                       setUnlimitedFields((prev) => ({
//                         ...prev,
//                         noOfCompanies: checked,
//                       }));
//                       if (unlimitedFields.noOfCompanies)
//                         form.setFieldValue("noOfCompanies", "");
//                       else form.setFieldValue("noOfCompanies", "Unlimited");
//                     }}
//                   />
//                 </Form.Item>
//               </Col> */}
//               <Col span={4}>
//                 <Form.Item label="No Of Companies" required>
//                   <Flex gap="middle" justify="start" align="center">
//                     {unlimitedFields.noOfCompanies ? (
//                       <Input
//                         placeholder="Unlimited"
//                         style={{ width: "100%" }}
//                         value="Unlimited"
//                         disabled
//                       />
//                     ) : (
//                       <Form.Item
//                         name="noOfCompanies"
//                         noStyle
//                         rules={[
//                           { required: true, message: "Please enter number!" },
//                         ]}
//                       >
//                         <InputNumber
//                           placeholder="Enter No Of Companies"
//                           style={{ width: "100%" }}
//                           min={1}
//                         />
//                       </Form.Item>
//                     )}
//                     <Switch
//                       checked={unlimitedFields.noOfCompanies}
//                       checkedChildren={
//                         <Infinity
//                           width={20}
//                           style={{ paddingBottom: "3px", marginRight: "40px" }}
//                         />
//                       }
//                       onChange={(checked) => {
//                         setUnlimitedFields((prev) => ({
//                           ...prev,
//                           noOfCompanies: checked,
//                         }));
//                         if (checked) {
//                           form.setFieldsValue({ noOfCompanies: undefined });
//                         }
//                       }}
//                     />
//                   </Flex>
//                 </Form.Item>
//               </Col>

//               {/* <Col span={4}>
//                 <Form.Item label="Unlimited Eways">
//                   <Switch
//                     checked={unlimitedFields.noOfEways}
//                     onChange={(checked) => {
//                       setUnlimitedFields((prev) => ({
//                         ...prev,
//                         noOfEways: checked,
//                       }));
//                       if (unlimitedFields.noOfEways)
//                         form.setFieldValue("noOfEways", "");
//                       else form.setFieldValue("noOfEways", "Unlimited");
//                     }}
//                   />
//                 </Form.Item>
//               </Col> */}
//               <Col span={4}>
//                 <Form.Item label="No Of Eways" required>
//                   <Flex gap="middle" justify="start" align="center">
//                     {unlimitedFields.noOfEways ? (
//                       <Input
//                         placeholder="Unlimited"
//                         style={{ width: "100%" }}
//                         value="Unlimited"
//                         disabled
//                       />
//                     ) : (
//                       <Form.Item
//                         name="noOfEways"
//                         noStyle
//                         rules={[
//                           { required: true, message: "Please enter number!" },
//                         ]}
//                       >
//                         <InputNumber
//                           placeholder="Enter No Of Eways"
//                           style={{ width: "100%" }}
//                           min={1}
//                         />
//                       </Form.Item>
//                     )}
//                     <Switch
//                       checked={unlimitedFields.noOfEways}
//                       checkedChildren={
//                         <Infinity
//                           width={20}
//                           style={{ paddingBottom: "3px", marginRight: "40px" }}
//                         />
//                       }
//                       onChange={(checked) => {
//                         setUnlimitedFields((prev) => ({
//                           ...prev,
//                           noOfEways: checked,
//                         }));
//                         if (checked) {
//                           form.setFieldsValue({ noOfEways: undefined });
//                         }
//                       }}
//                     />
//                   </Flex>
//                 </Form.Item>
//               </Col>

//               {/* <Col span={4}>
//                 <Form.Item label="Unlimited EInvoice">
//                   <Switch
//                     checked={unlimitedFields.noOfEInvoice}
//                     onChange={(checked) => {
//                       setUnlimitedFields((prev) => ({
//                         ...prev,
//                         noOfEInvoice: checked,
//                       }));
//                       if (unlimitedFields.noOfEInvoice)
//                         form.setFieldValue("noOfEInvoice", "");
//                       else form.setFieldValue("noOfEInvoice", "Unlimited");
//                     }}
//                   />
//                 </Form.Item>
//               </Col> */}
//               <Col span={4}>
//                 <Form.Item label="No Of EInvoice" required>
//                   <Flex gap="middle" justify="start" align="center">
//                     {unlimitedFields.noOfEInvoice ? (
//                       <Input
//                         placeholder="Unlimited"
//                         style={{ width: "100%" }}
//                         value="Unlimited"
//                         disabled
//                       />
//                     ) : (
//                       <Form.Item
//                         name="noOfEInvoice"
//                         noStyle
//                         rules={[
//                           { required: true, message: "Please enter number!" },
//                         ]}
//                       >
//                         <InputNumber
//                           placeholder="Enter No Of EInvoice"
//                           style={{ width: "100%" }}
//                           min={1}
//                         />
//                       </Form.Item>
//                     )}
//                     <Switch
//                       checked={unlimitedFields.noOfEInvoice}
//                       checkedChildren={
//                         <Infinity
//                           width={20}
//                           style={{ paddingBottom: "3px", marginRight: "40px" }}
//                         />
//                       }
//                       onChange={(checked) => {
//                         setUnlimitedFields((prev) => ({
//                           ...prev,
//                           noOfEInvoice: checked,
//                         }));
//                         if (checked) {
//                           form.setFieldsValue({ noOfEInvoice: undefined });
//                         }
//                       }}
//                     />
//                   </Flex>
//                 </Form.Item>
//               </Col>

//               {/* <Col span={4}>
//                 <Form.Item label="Unlimited User">
//                   <Switch
//                     checked={unlimitedFields.noOfUser}
//                     onChange={(checked) => {
//                       setUnlimitedFields((prev) => ({
//                         ...prev,
//                         noOfUser: checked,
//                       }));
//                       if (unlimitedFields.noOfUser)
//                         form.setFieldValue("noOfUser", "");
//                       else form.setFieldValue("noOfUser", "Unlimited");
//                     }}
//                   />
//                 </Form.Item>
//               </Col> */}
//               <Col span={4}>
//                 <Form.Item label="No Of User" required>
//                   <Flex gap="middle" justify="start" align="center">
//                     {unlimitedFields.noOfUser ? (
//                       <Input
//                         placeholder="Unlimited"
//                         style={{ width: "100%" }}
//                         value="Unlimited"
//                         disabled
//                       />
//                     ) : (
//                       <Form.Item
//                         name="noOfUser"
//                         noStyle
//                         rules={[
//                           { required: true, message: "Please enter number!" },
//                         ]}
//                       >
//                         <InputNumber
//                           placeholder="Enter No Of User"
//                           style={{ width: "100%" }}
//                           min={1}
//                         />
//                       </Form.Item>
//                     )}
//                     <Switch
//                       checked={unlimitedFields.noOfUser}
//                       checkedChildren={
//                         <Infinity
//                           width={20}
//                           style={{ paddingBottom: "3px", marginRight: "40px" }}
//                         />
//                       }
//                       onChange={(checked) => {
//                         setUnlimitedFields((prev) => ({
//                           ...prev,
//                           noOfUser: checked,
//                         }));
//                         if (checked) {
//                           form.setFieldsValue({ noOfUser: undefined });
//                         }
//                       }}
//                     />
//                   </Flex>
//                 </Form.Item>
//               </Col>

//               {/* <Col span={4}>
//                 <Form.Item label="Unlimited WP">
//                   <Switch
//                     checked={unlimitedFields.noOfWp}
//                     onChange={(checked) => {
//                       setUnlimitedFields((prev) => ({
//                         ...prev,
//                         noOfWp: checked,
//                       }));
//                       if (unlimitedFields.noOfWp)
//                         form.setFieldValue("noOfWp", "");
//                       else form.setFieldValue("noOfWp", "Unlimited");
//                     }}
//                   />
//                 </Form.Item>
//               </Col> */}

//               <Col span={4}>
//                 <Form.Item label="No Of Wp" required>
//                   <Flex gap="middle" justify="start" align="center">
//                     {unlimitedFields.noOfWp ? (
//                       <Input
//                         placeholder="Unlimited"
//                         style={{ width: "100%" }}
//                         value="Unlimited"
//                         disabled
//                       />
//                     ) : (
//                       <Form.Item
//                         name="noOfWp"
//                         noStyle
//                         rules={[
//                           { required: true, message: "Please enter number!" },
//                         ]}
//                       >
//                         <InputNumber
//                           placeholder="Enter No Of Wp"
//                           style={{ width: "100%" }}
//                           min={1}
//                         />
//                       </Form.Item>
//                     )}
//                     <Switch
//                       checked={unlimitedFields.noOfWp}
//                       checkedChildren={
//                         <Infinity
//                           width={20}
//                           style={{ paddingBottom: "3px", marginRight: "40px" }}
//                         />
//                       }
//                       onChange={(checked) => {
//                         setUnlimitedFields((prev) => ({
//                           ...prev,
//                           noOfWp: checked,
//                         }));
//                         if (checked) {
//                           form.setFieldsValue({ noOfWp: undefined });
//                         }
//                       }}
//                     />
//                   </Flex>
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="sales_invoice" label="Sales Invoice">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="sales_order" label="Sales Order">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="sales_challan" label="Sales Challan">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="sales_return" label="Sales Return">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="purchase_invoice" label="Purchase Invoice">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="purchase_order" label="Purchase Order">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="purchase_challan" label="Purchase Challan">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="purchase_return" label="Purchase Return">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="issue" label="Issue">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="receive" label="Receive">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="cash" label="Cash">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="bank" label="Bank">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="jv" label="JV">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="share_company" label="Share Company">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="stock_transfer" label="Stock Transfer">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item
//                   name="company_wise_master"
//                   label="Company Wish Master"
//                 >
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item
//                   name="delete_unused_master"
//                   label="Delete Unused Master"
//                 >
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="print_barcode" label="Print Barcode">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="isMobileApp" label="Mobile App">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="isCrm" label="Crm">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="isRojmel" label="Rojmel">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="isToDo" label="ToDo">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="isDailyWp" label="Daily Wp">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="is2a2b" label="2A2B">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="isDashboardGst" label="Dashboard Gst">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="is2stepVerify" label="Two Step Verify">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item name="bank_import" label="Bank Import">
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item
//                   name="aamne_saamne_sale_purchase"
//                   label="Aamne - Saamne Sale Purchase"
//                 >
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item
//                   name="multiple_eway_bill_generate"
//                   label="Multiple Eway Bill Generate"
//                 >
//                   <Switch />
//                 </Form.Item>
//               </Col>

//               <Col span={4}>
//                 <Form.Item
//                   name="bulk_update_suspense_account"
//                   label="Bulk Update Suspense Account"
//                 >
//                   <Switch />
//                 </Form.Item>
//               </Col>
//             </>
//           ) : null}
//         </Row>
//       </Form>
//     </Modal>
//   );
// };

// export default PackageTransactionForm;


import { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomers } from "../../store/actions/customers";
import { getPackage } from "../../store/actions/package";
import { Infinity } from "lucide-react";
import dayjs from "dayjs";

const SwitchField = ({ name, label, colClass = "col-md-4 col-6", formValues, handleChange }) => (
  <div className={`${colClass} mb-2`}>
    <div
      className="d-flex align-items-center justify-content-between border rounded px-3 py-2 h-100"
      style={{ minHeight: 42 }}
    >
      <label className="form-label mb-0 fw-medium" style={{ fontSize: 13 }}>
        {label}
      </label>
      <div className="form-check form-switch mb-0 ms-2">
        <input
          className="form-check-input"
          type="checkbox"
          role="switch"
          checked={!!formValues[name]}
          onChange={(e) => handleChange(name, e.target.checked)}
        />
      </div>
    </div>
  </div>
);

const UnlimitedField = ({ field, label, tabIndex, formValues, errors, unlimitedFields, setUnlimitedFields, handleChange }) => (
  <div className="col-md-4 col-6 mb-3">
    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
      {label} <span className="text-danger">*</span>
    </label>
    <div className="input-group input-group-sm">
      <input
        type="number"
        className={`form-control${errors[field] ? " is-invalid" : ""}`}
        placeholder={unlimitedFields[field] ? "Unlimited" : "Enter count"}
        value={unlimitedFields[field] ? "" : formValues[field] || ""}
        disabled={unlimitedFields[field]}
        min={1}
        tabIndex={tabIndex}
        onChange={(e) => handleChange(field, e.target.value)}
      />
      <button
        type="button"
        className={`btn btn-sm ${unlimitedFields[field] ? "btn-primary" : "btn-outline-secondary"}`}
        title="Toggle unlimited"
        onClick={() => {
          setUnlimitedFields((prev) => ({ ...prev, [field]: !prev[field] }));
          if (!unlimitedFields[field]) handleChange(field, "");
        }}
      >
        <Infinity size={16} />
      </button>
      {errors[field] && <div className="invalid-feedback d-block">{errors[field]}</div>}
    </div>
  </div>
);

const PackageTransactionForm = ({
  visible,
  onCreate,
  onCancel,
  record,
  businessType,
}) => {
  const dispatch = useDispatch();
  const customers = useSelector((state) => state.customers.list);
  const packages = useSelector((state) => state.packageReducer.list);

  const [activeTab, setActiveTab] = useState("basic");
  const [formValues, setFormValues] = useState({});
  const [errors, setErrors] = useState({});
  const [unlimitedFields, setUnlimitedFields] = useState({
    noOfCompanies: false,
    noOfEways: false,
    noOfEInvoice: false,
    noOfUser: false,
    noOfWp: false,
  });

  const formRef = useRef(null);
  const isEditMode = !!record?.id;

  const tabs = isEditMode
    ? [
      { key: "basic", label: "Basic Info" },
      { key: "limits", label: "Limits" },
      { key: "transactions", label: "Transactions" },
      { key: "features", label: "Features" },
    ]
    : [{ key: "basic", label: "Basic Info" }];

  useEffect(() => {
    dispatch(getCustomers());
    dispatch(getPackage());
  }, [dispatch]);

  useEffect(() => {
    if (record) {
      const unlimitedState = {
        noOfCompanies: record.noOfCompanies === -100,
        noOfEways: record.noOfEways === -100,
        noOfEInvoice: record.noOfEInvoice === -100,
        noOfUser: record.noOfUser === -100,
        noOfWp: record.noOfWp === -100,
      };
      setUnlimitedFields(unlimitedState);
      setFormValues({
        cusId: record.cusId || "",
        pId: record.pId || "",
        amount: record.amount || "",
        paymentMode: record.paymentMode || "",
        paymentRec: record.paymentRec || false,
        endDate: record.endDate ? dayjs(record.endDate, "YYYY-MM-DD").format("YYYY-MM-DD") : "",
        noOfCompanies: unlimitedState.noOfCompanies ? "" : record.noOfCompanies || "",
        noOfEways: unlimitedState.noOfEways ? "" : record.noOfEways || "",
        noOfEInvoice: unlimitedState.noOfEInvoice ? "" : record.noOfEInvoice || "",
        noOfUser: unlimitedState.noOfUser ? "" : record.noOfUser || "",
        noOfWp: unlimitedState.noOfWp ? "" : record.noOfWp || "",
        isMobileApp: record.isMobileApp || false,
        isCrm: record.isCrm || false,
        isRojmel: record.isRojmel || false,
        isToDo: record.isToDo || false,
        isDailyWp: record.isDailyWp || false,
        referralAmt: record.referralAmt || "",
        referralPer: record.referralPer || "",
        isDashboardGst: record.isDashboardGst || false,
        is2a2b: record.is2a2b || false,
        is2stepVerify: record.is2stepVerify || false,
        sales_challan: record.sales_challan || false,
        sales_invoice: record.sales_invoice || false,
        purchase_challan: record.purchase_challan || false,
        purchase_invoice: record.purchase_invoice || false,
        sales_return: record.sales_return || false,
        purchase_return: record.purchase_return || false,
        issue: record.issue || false,
        receive: record.receive || false,
        cash: record.cash || false,
        bank: record.bank || false,
        jv: record.jv || false,
        stock_transfer: record.stock_transfer || false,
        share_company: record.share_company || false,
        company_wise_master: record.company_wise_master || false,
        delete_unused_master: record.delete_unused_master || false,
        aamne_saamne_sale_purchase: record.aamne_saamne_sale_purchase || false,
        multiple_eway_bill_generate: record.multiple_eway_bill_generate || false,
        print_barcode: record.print_barcode || false,
        sales_order: record.sales_order || false,
        purchase_order: record.purchase_order || false,
        bank_import: record.bank_import || false,
        bulk_update_suspense_account: record.bulk_update_suspense_account || false,
      });
    } else {
      resetForm();
    }
  }, [record]);

  const resetForm = () => {
    setFormValues({});
    setErrors({});
    setActiveTab("basic");
    setUnlimitedFields({
      noOfCompanies: false,
      noOfEways: false,
      noOfEInvoice: false,
      noOfUser: false,
      noOfWp: false,
    });
  };

  const handleChange = (name, value) => {
    setFormValues((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formValues.cusId) newErrors.cusId = "Please select a customer!";
    if (!formValues.pId) newErrors.pId = "Please select a package!";
    if (!formValues.paymentMode) newErrors.paymentMode = "Please select a payment mode!";
    if (!formValues.amount) newErrors.amount = "Please enter the price!";

    if (isEditMode) {
      ["noOfCompanies", "noOfEways", "noOfEInvoice", "noOfUser", "noOfWp"].forEach((f) => {
        if (!unlimitedFields[f] && !formValues[f]) {
          newErrors[f] = "Please enter a number!";
        }
      });
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const basicFields = ["cusId", "pId", "paymentMode", "amount"];
      const limitFields = ["noOfCompanies", "noOfEways", "noOfEInvoice", "noOfUser", "noOfWp"];
      if (basicFields.some((f) => newErrors[f])) setActiveTab("basic");
      else if (limitFields.some((f) => newErrors[f])) setActiveTab("limits");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    const values = { ...formValues };

    if (isEditMode) {
      ["noOfCompanies", "noOfEways", "noOfEInvoice", "noOfUser", "noOfWp"].forEach((field) => {
        if (unlimitedFields[field]) {
          values[field] = -100;
        } else if (!values[field]) {
          values[field] = 0;
        } else {
          values[field] = Number(values[field]);
        }
      });
    }

    if (values.endDate) {
      values.endDate = dayjs(values.endDate).format("YYYY-MM-DD");
    }

    console.log("Submitting values:", values);
    onCreate(values);
    resetForm();
  };

  const handleCancel = () => {
    resetForm();
    onCancel();
  };

  // Enter key: move focus to next input/select within current tab
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key !== "Enter") return;
      const tag = e.target.tagName;
      if (tag !== "INPUT" && tag !== "SELECT") return;

      const focusable = Array.from(
        formRef.current?.querySelectorAll(
          `#tab-${activeTab} input:not([disabled]), #tab-${activeTab} select`
        ) || []
      ).filter((el) => el.offsetParent !== null);

      const idx = focusable.indexOf(e.target);
      if (idx >= 0 && idx < focusable.length - 1) {
        e.preventDefault();
        focusable[idx + 1].focus();
      } else if (idx === focusable.length - 1) {
        const nextTabIdx = tabs.findIndex((t) => t.key === activeTab) + 1;
        if (nextTabIdx < tabs.length) {
          e.preventDefault();
          setActiveTab(tabs[nextTabIdx].key);
          setTimeout(() => {
            const nextFocusable = formRef.current?.querySelectorAll(
              `#tab-${tabs[nextTabIdx].key} input:not([disabled]), #tab-${tabs[nextTabIdx].key} select`
            );
            if (nextFocusable?.length) nextFocusable[0].focus();
          }, 50);
        }
      }
    },
    [activeTab, tabs]
  );

  if (!visible) return null;

  const inputClass = (field) =>
    `form-control form-control-sm${errors[field] ? " is-invalid" : ""}`;

  const selectClass = (field) =>
    `form-select form-select-sm${errors[field] ? " is-invalid" : ""}`;

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.45)", zIndex: 10000 }}
      tabIndex={-1}
    >
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content" ref={formRef} onKeyDown={handleKeyDown}>

          {/* Header */}
          <div className="modal-header py-3">
            <h5 className="modal-title fw-semibold">
              {record?.id ? "Update Package Transaction" : "Add Package Transaction"}
            </h5>
            <button type="button" className="btn-close" onClick={handleCancel} />
          </div>

          {/* Tabs */}
          <div className="modal-body pt-0 pb-0">
            <ul className="nav nav-tabs mt-3" role="tablist">
              {tabs.map((tab) => (
                <li className="nav-item" key={tab.key}>
                  <button
                    className={`nav-link${activeTab === tab.key ? " active" : ""}`}
                    style={{ fontSize: 13 }}
                    onClick={() => setActiveTab(tab.key)}
                    type="button"
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>

            <div className="tab-content pt-3 pb-2" style={{ minHeight: 340 }}>

              {/* ── Tab 1: Basic Info ── */}
              <div
                id="tab-basic"
                className={`tab-pane${activeTab === "basic" ? " show active" : ""}`}
              >
                <div className="row g-3">

                  <div className="col-md-6">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      Customer <span className="text-danger">*</span>
                    </label>
                    <select
                      className={selectClass("cusId")}
                      value={formValues.cusId || ""}
                      disabled={!!record?.id}
                      tabIndex={1}
                      onChange={(e) => handleChange("cusId", e.target.value)}
                    >
                      <option value="">Select Customer</option>
                      {customers.map((c) => (
                        <option key={c.id} value={c.id}>{c.name}</option>
                      ))}
                    </select>
                    {errors.cusId && <div className="invalid-feedback d-block">{errors.cusId}</div>}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      Package <span className="text-danger">*</span>
                    </label>
                    <select
                      className={selectClass("pId")}
                      value={formValues.pId || ""}
                      disabled={!!record?.id}
                      tabIndex={2}
                      onChange={(e) => handleChange("pId", e.target.value)}
                    >
                      <option value="">Select Package</option>
                      {packages.map((p) => (
                        <option key={p.id} value={p.id}>{p.name}</option>
                      ))}
                    </select>
                    {errors.pId && <div className="invalid-feedback d-block">{errors.pId}</div>}
                  </div>

                  <div className="col-md-4">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      Payment Mode <span className="text-danger">*</span>
                    </label>
                    <select
                      className={selectClass("paymentMode")}
                      value={formValues.paymentMode || ""}
                      tabIndex={3}
                      onChange={(e) => handleChange("paymentMode", e.target.value)}
                    >
                      <option value="">Select Payment Mode</option>
                      <option value="Razorpay">Razorpay</option>
                      <option value="Cash">Cash</option>
                      <option value="Bank">Bank</option>
                      <option value="NEFT">NEFT</option>
                      <option value="UPI">UPI</option>
                    </select>
                    {errors.paymentMode && <div className="invalid-feedback d-block">{errors.paymentMode}</div>}
                  </div>

                  <div className="col-md-4">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      Price <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className={inputClass("amount")}
                      placeholder="Enter price"
                      value={formValues.amount || ""}
                      tabIndex={4}
                      onChange={(e) => handleChange("amount", e.target.value)}
                    />
                    {errors.amount && <div className="invalid-feedback">{errors.amount}</div>}
                  </div>

                  <div className="col-md-4">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      Payment Status
                    </label>
                    <div
                      className="d-flex align-items-center border rounded px-3"
                      style={{ height: 31 }}
                    >
                      <div className="form-check mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="paymentRec"
                          checked={!!formValues.paymentRec}
                          onChange={(e) => handleChange("paymentRec", e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="paymentRec"
                          style={{ fontSize: 13 }}
                        >
                          Full Payment Received
                        </label>
                      </div>
                    </div>
                  </div>

                  {isEditMode && (
                    <div className="col-md-4">
                      <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                        End Date
                      </label>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={formValues.endDate || ""}
                        tabIndex={5}
                        onChange={(e) => handleChange("endDate", e.target.value)}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* ── Tab 2: Limits (edit only) ── */}
              {isEditMode && (
                <div
                  id="tab-limits"
                  className={`tab-pane${activeTab === "limits" ? " show active" : ""}`}
                >
                  <p className="text-muted mb-3" style={{ fontSize: 12 }}>
                    Click ∞ to toggle unlimited access for a field.
                  </p>
                  <div className="row">
                    <UnlimitedField field="noOfCompanies" label="No. of Companies" tabIndex={20}
                      formValues={formValues} errors={errors}
                      unlimitedFields={unlimitedFields} setUnlimitedFields={setUnlimitedFields}
                      handleChange={handleChange}
                    />
                    <UnlimitedField field="noOfEways" label="No. of Eways" tabIndex={21}
                      formValues={formValues} errors={errors}
                      unlimitedFields={unlimitedFields} setUnlimitedFields={setUnlimitedFields}
                      handleChange={handleChange}
                    />
                    <UnlimitedField field="noOfEInvoice" label="No. of E-Invoice" tabIndex={22}
                      formValues={formValues} errors={errors}
                      unlimitedFields={unlimitedFields} setUnlimitedFields={setUnlimitedFields}
                      handleChange={handleChange}
                    />
                    <UnlimitedField field="noOfUser" label="No. of Users" tabIndex={23}
                      formValues={formValues} errors={errors}
                      unlimitedFields={unlimitedFields} setUnlimitedFields={setUnlimitedFields}
                      handleChange={handleChange}
                    />
                    <UnlimitedField field="noOfWp" label="No. of WP" tabIndex={24}
                      formValues={formValues} errors={errors}
                      unlimitedFields={unlimitedFields} setUnlimitedFields={setUnlimitedFields}
                      handleChange={handleChange}
                    />
                  </div>
                </div>
              )}

              {/* ── Tab 3: Transactions (edit only) ── */}
              {isEditMode && (
                <div
                  id="tab-transactions"
                  className={`tab-pane${activeTab === "transactions" ? " show active" : ""}`}
                >
                  <p className="text-muted mb-3" style={{ fontSize: 12 }}>
                    Enable the transaction types available in this package.
                  </p>
                  <div className="row g-2">
                    <SwitchField name="sales_invoice" label="Sales Invoice" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="sales_order" label="Sales Order" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="sales_challan" label="Sales Challan" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="sales_return" label="Sales Return" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="purchase_invoice" label="Purchase Invoice" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="purchase_order" label="Purchase Order" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="purchase_challan" label="Purchase Challan" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="purchase_return" label="Purchase Return" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="issue" label="Issue" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="receive" label="Receive" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="cash" label="Cash" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="bank" label="Bank" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="jv" label="JV" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="stock_transfer" label="Stock Transfer" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="share_company" label="Share Company" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="bank_import" label="Bank Import" formValues={formValues} handleChange={handleChange} />
                  </div>
                </div>
              )}

              {/* ── Tab 4: Features (edit only) ── */}
              {isEditMode && (
                <div
                  id="tab-features"
                  className={`tab-pane${activeTab === "features" ? " show active" : ""}`}
                >
                  <p className="text-muted mb-3" style={{ fontSize: 12 }}>
                    Enable advanced features included in this package.
                  </p>
                  <div className="row g-2">
                    <SwitchField name="isMobileApp" label="Mobile App" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="isCrm" label="CRM" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="isRojmel" label="Rojmel" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="isToDo" label="To Do" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="isDailyWp" label="Daily WP" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="is2a2b" label="2A2B" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="isDashboardGst" label="Dashboard GST" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="is2stepVerify" label="Two-Step Verify" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="company_wise_master" label="Company Wise Master" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="delete_unused_master" label="Delete Unused Master" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="print_barcode" label="Print Barcode" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="aamne_saamne_sale_purchase" label="Aamne Saamne Sale Purchase" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="multiple_eway_bill_generate" label="Multiple Eway Bill Generate" formValues={formValues} handleChange={handleChange} />
                    <SwitchField name="bulk_update_suspense_account" label="Bulk Update Suspense Account" formValues={formValues} handleChange={handleChange} />
                  </div>
                </div>
              )}

            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer py-2">
            <button
              type="button"
              className="btn btn-secondary btn-sm px-4"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary btn-sm px-4"
              onClick={handleSubmit}
            >
              {record?.id ? "Update" : "Submit"}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PackageTransactionForm;